/**
 * Webhooks guide — registering endpoints for run event notifications.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { webhooksGuideContent } from "@/constants/docs/webhooks-guide";

export const Route = createFileRoute("/docs/webhooks-guide")({
	component: WebhooksGuidePage,
});

function WebhooksGuidePage() {
	return <DocsPage title="Webhook Events" content={webhooksGuideContent} />;
}
